export const ROUTE_NAMES = {
  CATEGORY: 'category',
  TASKS: 'tasks',
  VNC: 'remoteViewer',
  SCHEDULE: 'schedule',
  CONSOLIDATED: 'consolidated',
  CONSOLIDATED_FULL: 'consolidatedFull',
  SUMMARY_REPORT: 'summaryReport',
  SUMMARY_USER_REPORT: 'summaryUserReport',
  WEBSITES: 'websites',
  PROGRAMS: 'programs',
  TRAFFIC_DETAILED: 'trafficDetailed',
};

export const ROUTE_IDS = {
  [ROUTE_NAMES.PROGRAMS]: 3,
  [ROUTE_NAMES.WEBSITES]: 10,
};

export const ROUTE_NAME_GROUP = {
  [ROUTE_NAMES.PROGRAMS]: 'groups',
  [ROUTE_NAMES.WEBSITES]: 'groupsWeb',
  [ROUTE_NAMES.TRAFFIC_DETAILED]: 'groupsWeb',
};

export const ROUTE_NAMES_PUPPETEER = [ROUTE_NAMES.SUMMARY_REPORT, ROUTE_NAMES.SUMMARY_USER_REPORT];
